export const env = {
  appTitle: import.meta.env.VITE_APP_TITLE || '创美药业管理系统',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || (import.meta.env.PROD ? '/api' : 'http://localhost:3000/api'),
  uploadUrl: import.meta.env.VITE_UPLOAD_URL || (import.meta.env.PROD ? '/api/upload' : 'http://localhost:3000/api/upload'),
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};
